// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__37429","question":"Question_question__3jXW3","description":"Question_description__m0xJc"};